import { Box, Stack, Tooltip, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import React from "react";

interface ParkingConfigControlProps {
  title: string;
  helpText: string;
  children: React.ReactNode;
  layout?: "row" | "column";
}

/**
 * Wrapper component for parking config controls
 * Adds a title and info tooltip above each control
 */
export const ParkingConfigControl: React.FC<ParkingConfigControlProps> = ({
  title,
  helpText,
  children,
  layout = "column",
}) => {
  return (
    <Box
      sx={{
        width: layout === "row" ? 180 : "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: layout === "row" ? "flex-start" : "stretch"
      }}
    >
      <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mb: 0.5, height: 20 }}>
        <Typography
          variant="caption"
          sx={{
            fontWeight: 500,
            fontSize: "0.7rem",
            color: "text.secondary",
            lineHeight: "20px"
          }}
        >
          {title}
        </Typography>
        <Tooltip title={helpText} placement="top" arrow>
          <InfoOutlinedIcon sx={{ fontSize: 14, color: "action.active", cursor: "help" }} />
        </Tooltip>
      </Stack>
      {children}
    </Box>
  );
};
